import Vue from 'vue';
import VueRouter from "vue-router";

import Lottery from './components/pages/Lottery';
import Results from './components/pages/Results';
import Tickets from './components/pages/Tickets';
import Tutorial from './components/pages/Tutorial';

Vue.use(VueRouter);

const routes = [
    {
        path: '/game/:gameId',
        name: 'lottery',
        component: Lottery,
        props: true,
    },
    {
        path: '/results/:gameId',
        name: 'results',
        component: Results,
    },
    {
        path: '/tickets/:gameId',
        name: 'tickets',
        component: Tickets,
    },
    {
        path: '/tutorial/:gameId',
        name: 'tutorial',
        component: Tutorial,
    },
];

const linkActiveClass = 'active';

export default new VueRouter({
    routes, linkActiveClass,
});